import { pages } from '@microsoft/teams-js';

interface ReferenceProps {
    documents: Array<{
        name: string;
        data: string;
        url: string | undefined;
    }>;
}

export function machineReferences(props: ReferenceProps) {

    const handleNavigateToFactoryTab = async (item: string) => {
        try {
            // Navigate to the Factory tab within the same Teams app
            await pages.currentApp.navigateTo({
                pageId: "index2", // Your Factory tab ID
                subPageId: item // Optional: pass machine data
            });
        } catch (error) {
            console.error('Navigation to Factory tab failed:', error);
        }
    };

    return (
        <div className="document-references">
            <h2>Referenced machines</h2>
            <ul className="list-disc pl-5">
                {props.documents
                    .filter((item, index, self) =>
                        item.url && self.findIndex(t => t.url === item.url) === index
                    )
                    .map((item, index) => (
                        <li key={index}>
                            <button
                                onClick={() => {
                                    if (item.url) {
                                        handleNavigateToFactoryTab(item.url.replace('machine://', ''));
                                    }
                                }}
                                className="text-chat-link underline hover:text-chat-link/80 border-none cursor-pointer p-0"
                            >
                                {item.url ? item.url.replace('machine://', '') : ''}
                            </button>
                        </li>
                    ))}
            </ul>
            {props.documents.length === 0 && <p>No document references available.</p>}
        </div>
    );
}